<template>
  <b-card header="eKey form">
    <b-form id="send-ekey-form">
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>Name</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input type="text" v-model="formData.name" placeholder="name" :state="formName"></b-form-input>
          <b-input-group-append>
            <b-input-group-text>
              <i class="fa fa-user"></i>
            </b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>Email</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input type="text" v-model="formData.email" placeholder="email" :state="formEmail"></b-form-input>
          <b-input-group-append>
            <b-input-group-text>
              <i class="fa fa-at"></i>
            </b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>Phone</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input type="text" v-model="formData.phone" placeholder="phone" :state="formPhone"></b-form-input>
          <b-input-group-append>
            <b-input-group-text>
              <i class="fa fa-phone"></i>
            </b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>Start</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            type="date"
            id="startDate"
            format="YYYY-MM-DD HH:mm:ss"
            v-model="formData.startDate"
            placeholder="StartDate"
          ></b-form-input>
          <b-form-input type="time" id="startTime" v-model="formData.startTime"></b-form-input>
          <b-input-group-append>
            <b-input-group-text>
              <i class="fa fa-calendar"></i>
            </b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>End</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input type="date" id="endDate" v-model="formData.endDate" placeholder="EndDate"></b-form-input>
          <b-form-input type="time" id="endTime" v-model="formData.endTime"></b-form-input>
          <b-input-group-append>
            <b-input-group-text>
              <i class="fa fa-calendar"></i>
            </b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <div class="form-group form-actions">
        <b-button @click.stop.prevent="submitData" type="submit" size="sm" variant="primary">Share</b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import EkeyList from "@/views/base/haus/EkeyList";
let qs = require("qs");
const constants = require("../shared/constants");
const BASE = constants.NEWPORT_CONST.API_URL;
const API = BASE + "/api/keys/sendKey";
const API_LIST = BASE + "/api/locks/listGuest";

function postdata(url, data, lockId) {
  const thisForm = document.getElementById("send-ekey-form");
  var partsStartDate = data.startDate.split("-");
  var partsEndDate = data.endDate.split("-");
  var partStartTime = data.startTime.split(":");
  var partEndTime = data.endTime.split(":");
  data.userName = thisForm.name.value;
  data.startDate = new Date(
    partsStartDate[0],
    partsStartDate[1] - 1,
    partsStartDate[2],
    partStartTime[0],
    partStartTime[1]
  ).getTime();
  data.endDate = new Date(
    partsEndDate[0],
    partsEndDate[1] - 1,
    partsEndDate[2],
    partEndTime[0],
    partEndTime[1]
  ).getTime();
  data.lockId = lockId;
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    method: "POST"
  }).then(res => res.json());
}

function postRefreshData(url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      accessToken: data.accessToken,
      authorization: data.accessToken
    },
    method: "POST"
  }).then(res => res.json());
}

async function getData(lockId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem("token"),
    lockId: lockId,
    pageSize: 10
  };
  let res = await postRefreshData(API_LIST, parameters);
  let result = res.list;
  return result;
}

export default {
  name: "ekey-form",
  components: {
    EkeyList
  },
  computed: {
    formName() {
      return this.$data.formData.name.length > 2 ? true : false;
    },
    formEmail() {
      return this.$data.formData.email.length > 6 ? true : false;
    },
    formPhone() {
      return this.$data.formData.phone.length > 5 ? true : false;
    }
  },
  data() {
    return {
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem("token"),
        lockId: "",
        email: "",
        name: "",
        phone: "",
        endDate: "",
        startDate: "",
        startTime: "",
        endTime: ""
      }
    };
  },
  props: ["locationName", "locationId", "locationDescription", "modalId"],
  mounted() {
    this.$data.formData.startDate = constants.getToday();
    this.$data.formData.endDate = constants.getEndDate();
    this.$data.formData.startTime = constants.getTimeNow();
    this.$data.formData.endTime = constants.getTimeNow();
  },
  methods: {
    submitData() {
      if (this.formName && this.formEmail && this.formPhone) {
        let lockId = this.$route.params.lockId;
        postdata(API, this.formData, lockId)
          .then(data => {
            getData(lockId).then(response => {
              this.formData.email = "";
              this.formData.name = "";
              this.formData.phone = "";
              this.formData.startdate = constants.getToday();
              this.formData.enddate = constants.getEndDate();
              this.formData.startTime = constants.getTimeNow();
              this.formData.endTime = constants.getTimeNow();
              this.$root.$emit("ekeylist", response);
              this.$root.$emit("modalShow", false);
            });
            console.log(data);
          })
          .catch(error => {
            console.error(error);
          });
        let loc = location.href;
        if (loc.indexOf("lockDetail") > 0) {
          this.$router.push("/base/lockDetail/" + lockId);
        } else {
          this.$router.push("/base/ekeylist/" + lockId);
        }
      }
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          alert("From Submitted!");
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/base/haus/EkeyForm.vue